/** 读取登录后缓存的权限码列表 */
export const getCachedPermissions = () => {
  try {
    const raw = localStorage.getItem('permissions');
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
};

export const setCachedPermissions = (codes) => {
  if (Array.isArray(codes)) {
    localStorage.setItem('permissions', JSON.stringify(codes));
  }
};

export const isPlatformAdmin = () => {
  const list = getCachedPermissions();
  if (list.includes('TENANT:MANAGE')) {
    return true;
  }
  try {
    const ctx = JSON.parse(localStorage.getItem('authContext') || '{}');
    if (ctx.platformAdmin) return true;
  } catch {
    /* ignore */
  }
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    if (user.username === 'admin') return true;
    const role = (user.userRole || '').toUpperCase();
    return role === 'PLATFORM_ADMIN' || role === 'SUPER_ADMIN';
  } catch {
    return false;
  }
};

/** 管理员/开发联调：手动开阀启泵；终端客户主路径应隐藏 */
const IRRIGATION_DEBUG_ADMIN_MARKERS = [
  'ADMIN',
  'SUPER_ADMIN',
  'PLATFORM_ADMIN',
  'TENANT_ADMIN',
  '管理员',
  '超级管理员',
  '平台管理员',
  '租户管理员'
];

export const isIrrigationDebugAdmin = () => {
  if (isPlatformAdmin()) return true;
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const tokens = [];
    const push = (v) => {
      const s = String(v || '').trim();
      if (s) tokens.push(s);
    };
    push(user.userRole);
    push(user.role);
    push(user.roleName);
    push(user.roleCode);
    const roles = Array.isArray(user.roles) ? user.roles : [];
    roles.forEach((r) => {
      if (typeof r === 'string') push(r);
      else if (r && typeof r === 'object') {
        push(r.roleCode);
        push(r.code);
        push(r.roleName);
        push(r.name);
      }
    });
    for (const raw of tokens) {
      const upper = raw.toUpperCase();
      for (const m of IRRIGATION_DEBUG_ADMIN_MARKERS) {
        if (raw === m || upper === m.toUpperCase() || upper.includes(m.toUpperCase())) {
          return true;
        }
      }
    }
  } catch {
    /* ignore */
  }
  return getCachedPermissions().includes('SYSTEM:MANAGE');
};

export const canManageSubTenants = () => {
  if (isPlatformAdmin()) return true;
  return hasPermission('TENANT:SUB_PROVISION') || hasPermission('TENANT:SUB_LIST');
};

export const canAccessTenantPage = () => {
  if (isPlatformAdmin()) return true;
  if (hasPermission('TENANT:PROVISION') || hasPermission('TENANT:MANAGE')) return true;
  return hasPagePermission('PAGE:SYSTEM:SUB_TENANT') || hasPagePermission('PAGE:SYSTEM:TENANT');
};

/** 平台审核小程序自助开通申请（与后端 TenantProvisionApplicationController 同权） */
export const canReviewTenantProvision = () => {
  if (isPlatformAdmin()) return true;
  return hasPermission('TENANT:PROVISION') || hasPermission('TENANT:MANAGE');
};

/** 成员加入申请审批（与后端 TenantMemberApplicationController 同权） */
export const canReviewMemberApplication = () => {
  if (isPlatformAdmin()) return true;
  return hasPermission('PAGE:SYSTEM:TENANT_MEMBER_APPLICATION')
    || hasPermission('TENANT_MEMBER:APPROVE')
    || hasPermission('TENANT_MEMBER:LIST')
    || hasPermission('USER:MANAGE')
    || hasPermission('TENANT:MANAGE');
};

export const hasPermission = (code) => {
  if (!code) return true;
  if (isPlatformAdmin()) return true;
  const list = getCachedPermissions();
  if (list.includes('SYSTEM:MANAGE')) return true;
  return list.includes(code);
};

/** 页面权限 */
export const hasPagePermission = (code) => {
  if (!code) return true;
  if (isPlatformAdmin()) return true;
  return hasPermission(code);
};

/** 按钮权限 */
export const hasButtonPermission = (code) => hasPermission(code);

/** 接口权限（前端仅用于提示，真实拦截在后端） */
export const hasApiPermission = (code) => hasPermission(code);

export const isSystemRole = (role) => {
  if (isPlatformAdmin()) return false;
  const code = String(role?.roleCode || role?.code || '').trim().toUpperCase();
  if (['PLATFORM_ADMIN', 'TENANT_ADMIN', 'ADMIN', 'SUPER_ADMIN'].includes(code)) {
    return true;
  }
  return !role?.tenantId;
};

export const filterByPermission = (items, getCode = (item) => item.permission) =>
  (items || []).filter((item) => {
    const code = getCode(item);
    return !code || hasPagePermission(code);
  });
